import styled from 'styled-components'

export const Label = styled.span`
	width: 100%;
	line-height: 16px;
`
